import { applyMiddleware, combineReducers, legacy_createStore as createStore } from 'redux';
import itemReducer from './reducers/itemReducer';
import categoryReducer from './reducers/categoryReducer';
import thunk from 'redux-thunk';
import logger from './middlewares/logger';

const reducers = combineReducers({
    itemReducer,
    categoryReducer
})

let store = createStore(reducers, applyMiddleware(logger, thunk));

export default store;